import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import useAuthStore from './stores/authStore';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/globals.css';
import './styles/hero.css';
import './styles/homepage.css';
import './styles/home-intro.css';
import './styles/projects.css';
import './styles/modals.css';
import './styles/login.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

async function bootstrap() {
  await useAuthStore.getState().bootstrapAuth();
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
}

void bootstrap();
